import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICustomerXPostingGroup } from "src/models/Customers/PostingGroup.models";

interface CustomerXPostingGroupState {
  customerXPostingGroups: ICustomerXPostingGroup[];
  customerXPostingGroupToEdit: ICustomerXPostingGroup | null;
}

const initialState: CustomerXPostingGroupState = {
  customerXPostingGroups: [],
  customerXPostingGroupToEdit: null,
};

const customerXPostingGroupSlice = createSlice({
  name: "CustomerXPostingGroup",
  initialState,
  reducers: {
    setCustomerXPostingGroupList: (
      state,
      action: PayloadAction<ICustomerXPostingGroup[]>
    ) => {
      state.customerXPostingGroups = action.payload;
    },
    concatListCustomerXPostingGroup: (
      state: CustomerXPostingGroupState,
      action: PayloadAction<ICustomerXPostingGroup[]>
    ) => {
      state.customerXPostingGroups = [
        ...state.customerXPostingGroups.concat(action.payload),
      ];
    },
    setCustomerXPostingGroupToEdit: (
      state,
      action: PayloadAction<ICustomerXPostingGroup | null>
    ) => {
      state.customerXPostingGroupToEdit = action.payload;
    },
    addCustomerXPostingGroup: (
      state,
      action: PayloadAction<ICustomerXPostingGroup>
    ) => {
      state.customerXPostingGroups.push(action.payload);
    },
    updateCustomerXPostingGroup: (
      state,
      action: PayloadAction<ICustomerXPostingGroup>
    ) => {
      let itemIndex = state.customerXPostingGroups.findIndex(
        item =>
          item.customerXPostingGroupId ===
          action.payload.customerXPostingGroupId
      );
      if (itemIndex !== -1)
        state.customerXPostingGroups[itemIndex] = action.payload;
    },
    deleteCustomerXPostingGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.customerXPostingGroups.filter(
        item => item.customerXPostingGroupId !== action.payload
      );
      state.customerXPostingGroups = newArray;
    },
  },
});

export const {
  setCustomerXPostingGroupList,
  concatListCustomerXPostingGroup,
  setCustomerXPostingGroupToEdit,
  addCustomerXPostingGroup,
  updateCustomerXPostingGroup,
  deleteCustomerXPostingGroup,
} = customerXPostingGroupSlice.actions;

export default customerXPostingGroupSlice.reducer;
